import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';

export default function UploadPdfField({ onFileChange, setSelectedFile, selectedFile }) {
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedFile(file);
            onFileChange(file); // envia o arquivo para o pai
        } else {
            setSelectedFile(null);
            onFileChange(null);
            toast.error('Por favor, envie um arquivo PDF.');
            document.getElementById('pdf-upload').value = '';
        }
    };

    const clearFile = () => {
        setSelectedFile(null);
        onFileChange(null);
        document.getElementById('pdf-upload').value = '';
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <TextField id="pdf-upload" type="file" accept="application/pdf" onChange={handleFileChange} />

            {selectedFile && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body2">{selectedFile.name}</Typography>
                    <Button color="error" onClick={clearFile} size="small">
                        Remover
                    </Button>
                </Box>
            )}
        </Box>
    );
}
